var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9113 31.4634C61.9113 14.4195 48.0933 0.601562 31.0494 0.601562C14.0054 0.601562 0.1875 14.4195 0.1875 31.4634C0.1875 48.5074 14.0054 62.3253 31.0494 62.3253C48.0933 62.3253 61.9113 48.5074 61.9113 31.4634ZM14.1573 31.1379C23.1543 27.2175 29.1531 24.634 32.1549 23.3851C40.7263 19.8203 42.5068 19.2007 43.6678 19.1802C43.9234 19.1766 44.4936 19.2392 44.8637 19.5394C45.1759 19.7926 45.2615 20.135 45.3025 20.3749C45.3435 20.616 45.3953 21.1621 45.3543 21.59C44.8902 26.4701 42.8806 38.3121 41.8583 43.778C41.4255 46.0915 40.5732 46.8666 39.7486 46.9426C37.9571 47.1078 36.5961 45.7576 34.8601 44.6195C32.144 42.8401 30.6094 41.731 27.9728 39.9939C24.9252 37.9854 26.9011 36.8823 28.6371 35.0789C29.0916 34.6063 36.9879 27.4237 37.141 26.7727C37.1603 26.6907 37.1784 26.3869 36.9975 26.2266C36.8167 26.0662 36.5503 26.1217 36.3586 26.1651C36.0861 26.2266 31.7474 29.0945 23.3411 34.769C22.1091 35.6153 20.9927 36.0264 19.9933 36.0059C18.8915 35.9818 16.7721 35.3827 15.1965 34.8703C13.264 34.2422 11.7282 33.9095 11.862 32.8426C11.9307 32.2868 12.6962 31.719 14.1573 31.1379Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.9e256c6192b92d05406e3e802790d073.svg";
export { ForwardRef as ReactComponent };